import { Field } from 'react-final-form'
import { NumericFormat } from 'react-number-format'
import Input from './BaseInput'
import { forwardRef } from 'react'

const FieldNumberInner = ({ input, meta, label, i18n, onValueChange, ...props }, ref) => {
  return (
    <NumericFormat
      {...props}
      value={input?.value ?? 0}
      onValueChange={vals => {
        const newValue = vals.floatValue ?? 0
        input.onChange(newValue)
        if (onValueChange) onValueChange({ ...vals, floatValue: newValue })
      }}
      customInput={Input}
      thousandSeparator={i18n?.language === 'pt-BR' ? '.' : ','}
      decimalSeparator={i18n?.language === 'pt-BR' ? ',' : '.'}
      decimalScale={2}
      getInputRef={ref}
      fixedDecimalScale
      allowLeadingZeros
      allowNegative={false}
      label={label}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error}
      isNumericString={false}
    />
  )
}

const FieldNumber = ({ name, label, i18n, onValueChange, inputRef, ...props }) => {
  return (
    <Field
      name={name}
      render={({ input, meta }) => (
        <FieldNumberInner
          ref={inputRef}
          input={input}
          meta={meta}
          label={label}
          i18n={i18n}
          onValueChange={onValueChange}
          {...props}
        />
      )}
    />
  )
}

export default FieldNumber

export const FieldNumberStandalone = forwardRef(
  ({ value, onValueChange, label, i18n, error, helperText, ...props }, ref) => {
    return (
      <NumericFormat
        {...props}
        value={value ?? 0}
        onValueChange={vals => {
          const newValue = vals.floatValue ?? 0
          if (onValueChange) onValueChange({ ...vals, floatValue: newValue })
        }}
        customInput={Input}
        getInputRef={ref}
        thousandSeparator={i18n?.language === 'pt-BR' ? '.' : ','}
        decimalSeparator={i18n?.language === 'pt-BR' ? ',' : '.'}
        decimalScale={2}
        fixedDecimalScale
        allowLeadingZeros
        allowNegative={false}
        label={label}
        error={!!error}
        helperText={helperText}
        isNumericString={false}
      />
    )
  },
)
